/**
 * Smileys texte → emoji Unicode (saisie live + envoi + affichage).
 * Motifs longs d’abord.
 */
const EMOTICON_TO_EMOJI: Array<[string, string]> = [
  [":-)", "😊"],
  [":)", "😊"],
  [":-D", "😃"],
  [":D", "😃"],
  [":-P", "😛"],
  [":-p", "😛"],
  [":P", "😛"],
  [":p", "😛"],
  [";-)", "😉"],
  [";)", "😉"],
  [":-(", "😢"],
  [":(", "😢"],
  [":-|", "😐"],
  [":|", "😐"],
  [":-O", "😮"],
  [":-o", "😮"],
  [":O", "😮"],
  [":o", "😮"],
  [":-*", "😘"],
  [":*", "😘"],
  ["<3", "❤️"],
  [":-/", "😕"],
  [":/", "😕"],
  [":\\", "😕"],
  ["xD", "😆"],
  ["XD", "😆"],
  ["^^", "😊"],
];

function isWordChar(ch: string | undefined): boolean {
  return ch != null && /[A-Za-z0-9_]/.test(ch);
}

/**
 * Remplace ;) :p :) etc. et recalcule la position du curseur
 * (pour conversion live dans le composeur / édition).
 */
export function expandEmoticonsWithCaret(
  text: string,
  caret: number
): { text: string; caret: number } {
  if (!text) return { text, caret: 0 };

  let out = "";
  let i = 0;
  let newCaret = caret;

  while (i < text.length) {
    let matched = false;
    for (const [face, emoji] of EMOTICON_TO_EMOJI) {
      if (!text.startsWith(face, i)) continue;
      const beforeOk = !isWordChar(text[i - 1]);
      const afterIdx = i + face.length;
      const afterOk = !isWordChar(text[afterIdx]);
      if (!beforeOk || !afterOk) continue;

      const faceEnd = afterIdx;
      out += emoji;
      if (caret > i) {
        if (caret >= faceEnd) {
          newCaret += emoji.length - face.length;
        } else {
          newCaret = out.length;
        }
      }
      i = faceEnd;
      matched = true;
      break;
    }
    if (!matched) {
      out += text[i]!;
      i += 1;
    }
  }

  return { text: out, caret: Math.max(0, Math.min(newCaret, out.length)) };
}

/** Remplace ;) :p :) etc. par des emoji (hors milieu de mot). */
export function expandEmoticons(text: string): string {
  return expandEmoticonsWithCaret(text, text.length).text;
}
